import { CloudFilled } from '@ant-design/icons';
import type { FeatureConfig } from '@skynet/feature-config';
import { LOANS_ARCHIVE_ROUTE_PATH, LOANS_ARCHIVE_URL } from './routes';

/**
 * The Loans domain's archive section. Unlike the Admin feature configs, `nav.url`
 * lives under `/loans` rather than `/admin`, and the section takes no entity id,
 * so the app registers the route without `withRedirectDefaults`.
 */
export const loansArchiveConfig = {
  domain: 'Loans',
  section: 'archive',
  route: {
    path: LOANS_ARCHIVE_ROUTE_PATH,
    load: async () => ({ default: (await import('./ArchivedLoansPage')).ArchivedLoansPage }),
  },
  nav: {
    key: 'loans.archive',
    label: 'Archive',
    icon: <CloudFilled />,
    url: LOANS_ARCHIVE_URL,
  },
  header: { label: 'Archive' },
  cerbosAction: 'read:loans:archive',
  needsEntityId: false,
} as const satisfies FeatureConfig;
